export default {
  namespaced: true,
  state: {
    file: undefined,
    comment: '',
    status: 'draft',
  },
  getters: {},
  actions: {
    setComment({ commit }, payload) {
      commit('SET_COMMENT', payload);
    },
    setStatus({ commit }, payload) {
      commit('SET_STATUS', payload);
    },
  },
  mutations: {
    SET_COMMENT(state, payload) {
      state.comment = payload;
    },
    SET_STATUS(state, payload) {
      state.status = payload;
    },
  },
};
